import { AnimatePresence, motion } from 'framer-motion';

interface NavProgressBarProps {
  isVisible: boolean;
}

/**
 * Lightweight top-of-screen progress bar for in-app navigation between pages.
 * Route swaps in this SPA are effectively instant, so this exists purely as a
 * quick "something happened" cue — unlike ConstructionLoader (full-screen
 * brand animation reserved for the very first cold load), this never blocks
 * the page and never replays the logo/name sequence, so clicking around the
 * site doesn't feel like it's re-announcing itself every time.
 */
export function NavProgressBar({ isVisible }: NavProgressBarProps) {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed top-0 left-0 right-0 z-200 h-0.75 pointer-events-none"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          <motion.div
            className="h-full"
            style={{
              background: 'linear-gradient(90deg, #c2410c 0%, #f97316 60%, #fdba74 100%)',
              boxShadow: '0 0 8px 1px rgba(249,115,22,0.65)',
            }}
            initial={{ width: '0%' }}
            animate={{ width: ['0%', '78%', '100%'] }}
            transition={{ duration: 0.5, times: [0, 0.72, 1], ease: 'easeOut' }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
